export const emailConfig = {
  serviceId: 'service_k8donku',
  templateId: 'template_wkcvkgr',
  publicKey: 'BeuLiv8Xt-a-QCUqD',
};

